import { Typography } from "@mui/material";
import React from "react";
import { openUserDialogAtom, userModalTabValue } from "../../atoms/usersTable";
import { useAtom } from "jotai";

export const UserAvailability = ({ availability }) => {
    const [, setOpenUserDialog] = useAtom(openUserDialogAtom);
    const [, setTabValue] = useAtom(userModalTabValue);

    // Function to count schedules based on availability timeblocks
    // The part of scheduleinfo after "SB|SC|" is the same for timeblocks under the same schedule
    const getScheduleCount = (availability) => {
        const schedules = new Set(
            availability.map((item) => {
                const schedulePart = item.scheduleinfo.split("|")[2]; // The part after "SB|SC|"
                return schedulePart;
            })
        );
        return schedules.size;
    };

    const scheduleCount = getScheduleCount(availability);

    const handleScheduleClick = () => {
        setOpenUserDialog(true);
        setTabValue(1);
    };

    return (
        <>
            <Typography
                onClick={handleScheduleClick}
                sx={{
                    textDecoration: "underline",
                    "&:hover": {
                        cursor: "pointer"
                    }
                }}
            >
                {scheduleCount > 0
                    ? `${scheduleCount} schedule${scheduleCount > 1 ? "s" : ""}`
                    : ""}
            </Typography>
        </>
    );
};
